import React from 'react';
import { Button } from '@betareader/design-system';
import { withTranslation } from 'react-i18next';
import Icon from '../AppIcon';

const LoadMore = ({ t, onLoadMore, loading }) => {
  const targetRef = React.useRef(null);
  const onLoadMoreRef = React.useRef(onLoadMore);
  const loadingRef = React.useRef(loading);
  onLoadMoreRef.current = onLoadMore;
  loadingRef.current = loading;

  React.useEffect(() => {
    if (!targetRef.current || typeof IntersectionObserver === 'undefined') return undefined;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting) && !loadingRef.current) {
        loadingRef.current = true;
        onLoadMoreRef.current();
      }
    }, { rootMargin: '10px 0px' });
    observer.observe(targetRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={targetRef} style={{ display: 'flex', justifyContent: 'center' }}>
      <Button variant="ghost" onClick={onLoadMore} disabled={loading} aria-busy={loading}>
        {loading ? (
          <><Icon name="spinner" loading aria-hidden="true" /> {t('Loading', 'Loading…')}</>
        ) : t('LoadMore')}
      </Button>
    </div>
  );
};

export default withTranslation()(LoadMore);
